import { Route, Routes } from 'react-router';

import { InvoiceFinanceSignup } from './InvoiceFinanceSignup/InvoiceFinanceSignup';
import { Signup } from './Signup';
import { BusinessDetails } from './steps/BusinessDetails/BusinessDetails';
import { BusinessType } from './steps/BusinessType/BusinessType';
import { DirectorInfo } from './steps/DirectorInfo/DirectorInfo';
import { SignupError } from './steps/SignupError/SignupError';
import { SpeakToDirector } from './steps/SpeakToDirector/SpeakToDirector';
import { useIsInvoiceFinanceSignup } from './steps/useIsInvoiceFinanceSignup';

export const SIGNUP_BASE_PATH = '/pay/signup/';

export const SignupRoutes = () => {
  return (
    <Signup>
      <Routes>
        <Route path="/speak-to-director" element={<SpeakToDirector />} />
        <Route path="/error" element={<SignupError />} />
        <Route path="/details/:stepname" element={<SignupContent />} />
        <Route path="/*" element={<SignupContent />} />
      </Routes>
    </Signup>
  );
};

const SignupContent = () => {
  const isInvoiceFinance = useIsInvoiceFinanceSignup();

  if (isInvoiceFinance) return <InvoiceFinanceSignup />;

  return <BusinessDetailsRoutes />;
};

export const BusinessDetailsRoutes = () => {
  return (
    <div className="grid grid-cols-1 gap-xl">
      <BusinessType />
      <BusinessDetails />
      <DirectorInfo />
    </div>
  );
};
